
import { LiquidityHistory } from "../models/liqhistory.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getCurrentLiquidityValue = (group_id: number): Promise<LiquidityHistory> => {
    return new Promise<LiquidityHistory>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/liqHistory/${group_id}`).then((response) => {
            resolve(response.data as LiquidityHistory);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};